import { request } from '@langlois/request';

export async function edit ({ commit, getters }, { clubId, data }) {
	try {
		const originalClub = getters[`getById`](clubId);
		const patchCommands = [];
		const updatedClub = { ...originalClub };

		for (const pair of data.entries()) {
			const key = pair[0];
			const value = pair[1];

			if (key === `logo`) continue;

			if (value !== originalClub[key]) {
				patchCommands.push({
					operation: `replace`,
					path: `/${key}/`,
					value
				});

				updatedClub[key] = value;
			}
		}

		const url = new URL(`${process.env.VUE_APP_API_URI}/club/club/${clubId}`);

		const response = await request.patch(url, patchCommands);

		if (!response.ok) return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while saving the changes.`,
			type: `warning`
		}, { root: true });

		commit(`edit`, updatedClub);
		commit(`vcl/overlay/close`, null, { root: true });
	} catch (error) {
		commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while saving the changes.`,
			type: `warning`
		}, { root: true });
	}
}
